import React from 'react';
import { motion } from 'framer-motion';
import { 
  FaUserGraduate, 
  FaBullhorn, 
  FaUsers, 
  FaChalkboardTeacher, 
  FaHandshake 
} from 'react-icons/fa';
import './HowItWorks.css';

const HowItWorks = () => {
  const steps = [
    {
      number: 1,
      icon: <FaUserGraduate size={40} color="#fff" />,
      title: "Créez votre profil",
      description: "Vous pouvez créer un profil étudiant, expert, mentor ou entreprise."
    },
    {
      number: 2,
      icon: <FaBullhorn size={40} color="#fff" />,
      title: "Publiez ou recherchez",
      description: "Postez ou consultez des annonces emploi, logement, dons, accompagnement, etc."
    },
    {
      number: 3,
      icon: <FaUsers size={40} color="#fff" />,
      title: "Envoyez des messages",
      description: "Contactez étudiants, mentors ou experts pour poser vos questions."
    },
    {
      number: 4,
      icon: <FaChalkboardTeacher size={40} color="#fff" />,
      title: "Participez aux événements",
      description: "Webinaires animés par nos experts sur des thématiques précises."
    },
    {
      number: 5,
      icon: <FaHandshake size={40} color="#fff" />,
      title: "Obtenez une permanence",
      description: "Échangez directement avec un expert lors d'une permanence téléphonique."
    }
  ];

  return (
    <section className="how-it-works-section">
      <div className="how-it-works-container">
        <motion.h2 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="how-it-works-title"
        >
          Comment ça marche ?
        </motion.h2>
        
        <div className="how-it-works-steps">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              className="how-it-works-step-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="how-it-works-step-number">{step.number}</div>
              <div className="how-it-works-step-icon">{step.icon}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;